var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"closable-alerts"},_vm._l((_vm.alerts),function(alert){return _c('v-alert',{key:alert.id,attrs:{"border":"left","type":alert.type,"dismissible":"","dark":""},model:{value:(alert.showAlert),callback:function ($$v) {_vm.$set(alert, "showAlert", $$v)},expression:"alert.showAlert"}},[_vm._v(" "+_vm._s(alert.message)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }